// Packages
import React from 'react';
import './LegalDisclaimers.scss';

const LegalDisclaimers = () => {
  // =============================================
  // Helpers (Memo, CB, vars)
  // =============================================

  // =============================================
  // Return
  // =============================================

  return (
    <div className="footer-print-container" id="legalDisclaimers">
      <div className="legal-header">
        <div className="legal-title">Charter Communications</div>
        <div className="header-title">Confidential</div>
        <div style={{ flex: 1 }} />
      </div>
      <div className="legal-content">
        This calculator provides an estimate of savings based on information you
        provide. Serviceability and pricing may vary. This estimate is for
        discussion purposes only and is not intended to give rise to binding
        obligations for either party. Estimates do not include any taxes, fees,
        or surcharges for any Spectrum services.
      </div>
    </div>
  );
};

export default LegalDisclaimers;
